import React from 'react'
import { connect } from 'react-redux'

import Button from 'components/Button'
import actions from 'store/actions'

import ufanetLogo from 'assets/images/ufanet-logo.svg'
import iconEyeOn from 'assets/images/eye.svg'
import iconEyeOff from 'assets/images/eye-off.svg'

class Login extends React.Component {
  state = {
    errorText: '',
    isVisiblePassword: false,
  }

  componentDidMount() {
    document.title = 'СКУД - Вход в личный кабинет'
  }

  /**
   * @param {Object} e
   */
  handleChangeInput = e => {
    const name = e.target.name
    const value = e.target.value
    this[name] = value
  }

  /**
   * @param {Object} e
   * @return {Boolean|Undefined}
   */
  handleSubmit = async e => {
    e.preventDefault()

    if (!this.login || !this.password) {
      this.setState({ errorText: 'Не указан номер договора или пароль.' })
      return false
    }

    const data = {
      login: this.login,
      password: this.password,
    }

    try {
      await this.props.fetchTokens(data)
    } catch (error) {
      this.setState({ errorText: error })
    }
  }

  /**
   * Отобразить/скрыть введенный пароль
   */
  changeVisibilityPassword = () => {
    let input = document.getElementById('password')

    if (input.type === 'password') {
      input.type = 'text'
    } else {
      input.type = 'password'
    }
    this.setState(prevState => ({
      isVisiblePassword: !prevState.isVisiblePassword,
    }))
  }

  render() {
    const { errorText, isVisiblePassword } = this.state

    return (
      <div className='login'>
        <div>
          <h1 className='login__title'>СКУД</h1>
          <p className='login__subtitle'>Вход</p>

          <form onSubmit={this.handleSubmit}>
            <input
              className='input input--lg'
              type='text'
              placeholder='Номер договора'
              name='login'
              onChange={this.handleChangeInput}
            />
            <div className='wrapper-input-pswd'>
              <input
                className='input input--lg'
                type='password'
                placeholder='Пароль'
                name='password'
                onChange={this.handleChangeInput}
                id='password'
              />
              <button
                type='button'
                className='btn btn--padding0'
                onClick={this.changeVisibilityPassword}>
                <img
                  src={isVisiblePassword ? iconEyeOn : iconEyeOff}
                  alt={isVisiblePassword ? 'Скрыть пароль' : 'Показать пароль'}
                  title={
                    isVisiblePassword ? 'Скрыть пароль' : 'Показать пароль'
                  }
                />
              </button>
            </div>

            {errorText && <p className='error'>{errorText}</p>}
            <Button
              className='btn--primary btn--lg'
              type='submit'
              title='Войти'
            />
          </form>
        </div>

        <a
          href='https://www.ufanet.ru'
          target='_blank'
          rel='noopener noreferrer'>
          <img
            src={ufanetLogo}
            alt='ufanet logo'
            title='Перейти на сайт ufanet.ru'
          />
        </a>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchTokens: data => dispatch(actions.tokens.fetchTokens(data)),
  }
}

export default connect(null, mapDispatchToProps)(Login)
